import { render } from "./PageListSortable.vue?vue&type=template&id=f7f64ae6"
import script from "./PageListSortable.vue?vue&type=script&lang=js"
export * from "./PageListSortable.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__